import React, { useEffect } from "react";
import { checkVendorSlug, nameToSlug } from "../../../helpers";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Spinner } from "../../../assets";

const statuses = [
	[true, "Good", "good"],
	[false, "Taken", "bad"],
	["loading", <Spinner />, "loading"],
	["creating", <Spinner />, "creating"],
	[null, "...", ""]
];

export default function UrlSection({ values, onChange, currentShop }) {

	const { token } = useSelector(state => state.session);
	const [status, setStatus] = useState(null);
	const [error, setError] = useState(null);
	const [slug, setSlug] = useState(values.slug || "");

	useEffect(() => {
		if (status === true && values.slug !== slug) {
			onChange({ slug });
		} else if (status !== true && values.slug !== null) {
			onChange({ slug: null });
		}
	}, [status, values.slug, slug, onChange, currentShop]);

	useEffect(() => {
		if (!slug) {
			setStatus(null);
			return;
		} else if (currentShop && currentShop.slug === slug) {
			setStatus(true);
			return;
		}
		setStatus("loading");
		const to = setTimeout(() => {
			setError(null);
			checkVendorSlug(slug, token)
				.then(result => {
					const status = result.available;
					setStatus(status);
				})
				.catch(error => {
					setStatus(null);
					setError(error);
				});
		}, 1000);
		return () => {
			clearTimeout(to);
		}
	}, [slug, token, currentShop]);

	const [, statusMessage, statusClass] = statuses.find(([s]) => s === status);

	return <div className="urlSection">
		<div className="details">
			This is the address on the internet for your shop. Here's what it will look like:
			<br /><br />
			<span className="lighter" style={{
				display: "inline-block",
				padding: "5px 10px"
			}}>
				https://be.orderabl.com/with/{slug ? <b>{slug}</b> : <b>my-shop-url</b>}
			</span>
			<br /><br />
			The shop’s URL is important, and you can’t change it whenever you want, so try and pick a good one.
		</div>
		<div className="statusInput">
			<div className={`statusBar text-center statusBar-${statusClass}`}>{statusMessage}</div>
			<input
				// autoFocus={true}
				className={status === true ? "good" : ""}
				placeholder="my-shop-url"
				type="text"
				value={slug}
				onChange={e => setSlug(nameToSlug(e.target.value))}
			/>
		</div>
		{
			error
				?
				<>
					<br />
					<div className="error">
						{error}
					</div>
					<br /><br />
				</> : <>
					<br /><br />
				</>
		}
	</div >
} 
